import type { QueryClient } from '@tanstack/react-query';
import { isNil } from 'remeda';
import type { LoaderFunctionArgs } from 'react-router-dom';

import { routerQueryLoaderFn } from '@/shared/utils/query-client.utils';
import type { LoaderStore } from '@/stores';
import { getProductsQuery } from '@/features/billing/api/get-products.query';
import { countriesQuery } from '@/features/billing/api/get-countries.query';
import { vatQuery } from '@/features/billing/api/vat-info-query.hook';
import type { SubscribedUser } from '@/features/auth/types';
import { couponQuery } from '@/features/billing/api/get-coupon.query';

export const extraCreditsRouteLoader =
  (
    queryClient: QueryClient,
    globalLoaderActions: LoaderStore['actions'],
    user: SubscribedUser,
  ) =>
  async ({ request }: LoaderFunctionArgs) => {
    globalLoaderActions.show();

    const {
      billing: { country, vatId },
    } = user;

    const url = new URL(request.url);
    const couponCodeUrlParam = url.searchParams.get('coupon');

    const data = await Promise.all([
      routerQueryLoaderFn(queryClient, getProductsQuery()),

      routerQueryLoaderFn(queryClient, countriesQuery()),

      isNil(country) || country.length === 0
        ? undefined
        : routerQueryLoaderFn(queryClient, vatQuery([country, vatId || ''])),

      isNil(couponCodeUrlParam)
        ? undefined
        : routerQueryLoaderFn(
            queryClient,
            couponQuery([{ couponCode: couponCodeUrlParam }]),
          ),
    ]);

    globalLoaderActions.hide();

    return data;
  };
